import React from 'react'
import { NavLink } from 'react-router-dom'

import { RoutePath } from '@/routes'

// import { LogoLottie } from '../common/Lottie'

const LogoWithName: React.FC = () => {
  return (
    <NavLink to={RoutePath.HOME} className="flex items-center">
      <img className="flex-grow-0 flex-shrink-0 w-10" src="/static/images/logo.png" alt="XPUMP" />
      <img className="w-[150px]" src="/static/images/xpump.svg" alt="XPUMP" />
    </NavLink>
  )
}

export default LogoWithName
